<template>
  <div class="section tests">
    <div class="section">
      <h4 class="section-title">Legutóbbi kampányok</h4>
      <div class="section-content">
        <template v-if="campaigns.length > 0">
          <div class="table-fix-head table-height-170">
            <table class="table table-light">
              <thead>
                <tr>
                  <th scope="col" class="p-2 pb-3">Dátum</th>
                  <th scope="col" class="p-2 pb-3">Kampánynév</th>
                  <th scope="col" class="text-right p-2 pb-3">Megnyitási adatok</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(campaign, index) in this.campaigns"
                  :key="`c${index}`"
                  @click="selectedCampaignIndex = index"
                  class="clickable-row"
                  :class="index === selectedCampaignIndex ? 'table-info': ''"
                >
                  <td class="p-2">{{ displayFormatDate(campaign.dispatched_at !== null ? campaign.dispatched_at : campaign.updated_at) }}</td>
                  <td class="p-2">{{ campaign.name }}</td>
                  <td class="text-right p-2">
                    <span class="badge" :class="stateClass(campaign.result_state)">{{ stateLabel(campaign.result_state) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="campaigns.length === 0">
          Nincs elérhető kampány.
        </template>
      </div>
    </div>
    <div class="section">
      <h4 class="h4 section-title d-flex">
        <div class="w-75">Ajánlások dimenzióinak alakulása a kontroll tárgyhoz képest</div>
        <div class="w-25">
        </div>
      </h4>
      <div class="section-content">
        <template v-if="testsData.length > 0">
          <b-container>
            <b-row>
              <b-col cols="7">
                <dimensions :display="testDisplay" :tests="testsData" :width="500" :height="480"></dimensions>
              </b-col>
              <b-col cols="5" :class="{disabled: campaignsLoading}">
                <div class="small text-danger my-2" v-if="selectedCampaign !== null && selectedCampaign.result_state === 'partial'">
                  A kiválasztott kampány néhány tesztesetéhez nem érhetőek el megnyitási adatok.
                </div>
                <div class="small text-danger my-2" v-if="selectedCampaign !== null && selectedCampaign.result_state === 'none'">
                  A kiválasztott kampányhoz nem érhetőek el megnyitási adatok.
                </div>
                <h6>Tesztesetek</h6>
                <div>
                  <b-form-checkbox
                    class="border-bottom mb-2 pb-2"
                    :class="{indeterminate}"
                    v-model="selectAllTests"
                    name="testCheckboxAll"
                    switch
                  >
                    <span>Összes teszteset</span>
                  </b-form-checkbox>
                  <div
                    class="custom-control custom-switch"
                    v-for="(test, index) in availableTests"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      autocomplete="off"
                      class="custom-control-input action-color"
                      v-model="selectedTests"
                      :value="test.value"
                      :id="`testCheckbox${test.value}`"
                      name="testCheckboxes"
                      :disabled="test.disabled"
                    >
                    <label class="custom-control-label" :for="`testCheckbox${test.value}`" :style="{'--action-color': test.color}">
                      <span v-html="test.html"></span>
                    </label>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </template>
        <template v-if="testsData.length === 0">
          Nincsenek elérhető ajánlások.
        </template>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  tr.clickable-row {
    cursor: pointer;
  }

  .custom-control-input.action-color:disabled:checked ~ .custom-control-label::before,
  .custom-control-input.action-color:checked ~ .custom-control-label::before {
    background-color: var(--action-color);
    border-color: var(--action-color);
  }

  .custom-control-input.action-color:disabled:checked ~ .custom-control-label::before {
    opacity: 0.5;
  }

  .custom-switch.indeterminate .custom-control-input ~.custom-control-label {
    &::after {
      transform: translateX(0.4rem);
    }

    &::before {
      opacity: 0.5
    }
  }
</style>
<script>
  import moment from 'moment'
  import Loading from '../../common/LoadingPlaceholder'
  import Dimensions from './Dimensions'
  import { sortTests, getTestLabel, computeTestLabel } from '../../../util'
  import { Color } from '../../../utils/Color'
  import { displayFormatDate } from '../../../utils/Date'

  export default {
    components: {
      'dimensions': Dimensions,
      'loading': Loading
    },
    data() {
      return {
        campaignsLoading: true,
        campaigns: [],
        selectedTests: [],
        selectedCampaignIndex: -1,
        testDisplay: {},
        selectAllTests: true,
      }
    },
    computed: {
      selectedCampaign() {
        return this.campaigns.length > 0 && this.selectedCampaignIndex > -1 ? this.campaigns[this.selectedCampaignIndex] : null
      },
      indeterminate(indeterminate) {
        return !(this.selectedTests.length === 1 || this.selectedTests.length === this.availableTests.length)
      },
      availableTests() {
        if(this.selectedCampaign !== null) {
          var tests = this.selectedCampaign.tests
          sortTests(tests)

          if(tests.length === 0) {
            return []
          }

          var controlOpenRate = this.getOpenRate(tests[0])

          return _.map(tests, (test, index) => {
            var label = computeTestLabel(index, tests.length)
            var id = !test.is_control ? test.action.id : -1
            var action = test.is_control || test.is_combined ? '' : test.action.actionName

            var openRateLabel = this.getOpenRateLabel(test, controlOpenRate)
            var border = openRateLabel.value.length > 0 && action.length > 0 ? 'pl-2 border-left' : ''

            return {
              html:
                `<strong class="text-info">
                  <span class="action-label mr-1">${label}</span>${action}
                </strong>
                <strong class="ml-2 ${border} ${openRateLabel.class}">${openRateLabel.value}</strong>
                <p class="small mt-1">${test.subject}</p>`,
              value: test.id,
              color: test.is_control ? 'var(--lingusta-green)' : Color.action(id).toString(),
              action: test.action,
              disabled: test.is_control
            }
          })
        } else {
          return []
        }
      },
      testsData() {
        if(this.selectedCampaign !== null) {
          return this.selectedCampaign.tests
        } else {
          return []
        }
      }
    },
    watch: {
      selectAllTests(all) {
        if(this.selectedTests.length === 0) {
          return
        }

        this.selectedTests = [this.availableTests[0].value]

        if(all) {
          this.availableTests.forEach((test, index) => {
            if(index === 0) {
              return
            }

            this.selectedTests.push(test.value)
          })
        }
      },
      selectedCampaignIndex(campaign) {
        if(this.campaigns.length > 0 && campaign > -1) {

          this.selectedTests = _.map(this.campaigns[campaign].tests, test => test.id)
          this.testDisplay = _.reduce(this.campaigns[campaign].tests, (result, test) => {
            result[test.id] = {
              visible: true,
            }
            return result
          }, {})
        }

        this.selectAllTests = true
      },
      selectedTests(selectedTests) {
        this.testDisplay = _.forEach(this.testDisplay, (test, id) => {
          var id = parseInt(id)

          test.visible = _.findIndex(selectedTests, (selected, index) => {
            return selected === id
          }) !== -1

        })
      },
      campaigns(campaigns) {
        if(campaigns.length > 0) {
          this.selectedCampaignIndex = 0
        }
      },
    },
    mounted() {
      this.updateCampaigns()
    },
    methods: {
      stateLabel(state) {
        switch(state) {
          case 'full':
            return 'Teljes'
          case 'partial':
            return 'Részleges'
          case 'none':
            return 'Nincs'
          default:
            return 'Ismeretlen'
        }
      },
      stateClass(state) {
        switch(state) {
          case 'full':
            return 'badge-success'
          case 'partial':
            return 'badge-warning'
          case 'none':
            return 'badge-danger'
          default:
            return 'badge-secondary'
        }
      },
      displayFormatDate,
      getOpenRateLabel(test, controlOpenRate) {
        if(controlOpenRate === 0) {
          return {
            class: 'text-info',
            value: ''
          }
        }

        if(test.mailing === null) {
          return {
            class: 'text-danger',
            value: 'N/A'
          }
        }

        if(test.is_control) {
          return {
            class: 'text-info',
            value: `${this.formatPercent(controlOpenRate)}%`
          }
        } else {
          var openRate = this.getOpenRate(test)
          var additionalOpenRate = this.formatPercent(openRate - controlOpenRate)

          if(additionalOpenRate > 0) {
            return {
              class: 'text-success',
              value: `+${additionalOpenRate}%`
            }
          } else if(additionalOpenRate < 0) {
            return {
              class: 'text-danger',
              value: `${additionalOpenRate}%`
            }
          } else if(additionalOpenRate === 0) {
            return {
              class: 'text-info',
              value: `${this.formatPercent(openRate)}%`
            }
          } else {
            return {
              class: 'text-info',
              value: ''
            }
          }
        }
      },
      getOpenRate(test, controlOpenRate) {
        if(test.mailing === null || !test.mailing.recipients) {
          return 0
        }

        var opens = test.mailing.opens_unique !== 0 ? test.mailing.opens_unique : test.mailing.opens
        if(!opens) {
          return 0
        }

        return opens / test.mailing.recipients
      },
      formatPercent(num) {
        return Math.round((num + Number.EPSILON) * 100)
      },
      updateCampaigns() {
        this.campaignsLoading = true
        this.$http.get(this.$url('api.statistics.test-campaigns.index'))
          .then(({data}) => {
            this.campaigns = data
            this.campaignsLoading = false
          })
      },
    }
  }
</script>